import Link from 'Component/Link';
import {
    SearchOverlay as SourceSearchOverlay
} from 'SourceComponent/SearchOverlay/SearchOverlay.component';
import { appendWithStoreCode } from 'Util/Url';

import {
    AMOUNT_OF_PLACEHOLDERS
} from './SearchOverlay.config';

import './SearchOverlay.override.style';

/** @namespace Elganso/Component/SearchOverlay/Component */
export class SearchOverlayComponent extends SourceSearchOverlay {
    renderSearchResults() {
        const { searchResults, isLoading } = this.props;

        if (!searchResults.length && !isLoading && !this.timeout) {
            return this.renderNoResults();
        }

        const resultsToRender = (isLoading || this.timeout) ? Array(AMOUNT_OF_PLACEHOLDERS).fill({}) : searchResults;

        return (
            <ul
              block="SearchOverlay"
              elem="ItemsHolder"
            >
                { resultsToRender.map((item, i) => this.renderSearchItem(item, i)) }
                { this.renderSeeAllItems() }
            </ul>
        );
    }

    renderSeeAllItems() {
        const {
            searchCriteria
        } = this.props;
        const url = `search/${searchCriteria}`;
        return (
            <li className="SearchItem">
                 <Link to={ appendWithStoreCode(url) } className="Button">
                 { __('Ver más resultados') }
                 </Link>
            </li>
        );
    }
}

export default SearchOverlayComponent;
